// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RdVL","content":"styles_content__1M57d"};